<div
  class="soft-modal-content"
  [ngClass]="config.class"
  (softClickOutside)="
    dismiss(
      config.dismiss === true || (config.dismiss && config.dismiss.backdrop)
    )
  "
  [delayClickOutsideInit]="true"
  [clickOutsideEvents]="['mousedown']"
  >
  @if (config.dismiss === true || (config.dismiss && config.dismiss.button)) {
    <div
      class="closeBtn"
      >
      <i
        class="fa-regular fa-xmark modal-dismiss-button"
      (click)="
        dismiss(
          config.dismiss === true || (config.dismiss && config.dismiss.button)
        )
      "
      ></i>
    </div>
  }
  <template #container> </template>
</div>
